<!-- Admin: mesma página fake usada em carousel/stories/inline/discover, com o
     popup arrastável posicionado dentro do card (confineToBoundary usa o
     .ss-l-fake-page-wrapper como offsetParent, igual antes com .ss-l-popup-admin-wrapper) -->
<app-fake-page-preview [isAdmin]="isAdmin" *ngIf="isAdmin">
  <!-- Popup posicionado no canto correto dentro do card -->
  <div #draggablePopupEl appDraggable [position]="position" [resetPosition]="resetPosition" [confineToBoundary]="true"
    (dragEnd)="onDragEnd()" class="ss-l-popup-preview" [ngClass]="[getDialogClass(), position]"
    [class.ss-l-admin-mode]="adminModeActive"
    (mouseenter)="onDialogMouseEnter()" (mouseleave)="onDialogMouseLeave()">
    <div class="ss-l-dialogBody">
      <div #highlightElement class="ss-l-highlight pr-3 pl-3 pb-1 pt-1"
        *ngIf="highlight && highlight.length > 0 && showHighlight"
        [ngStyle]="{ 'background-color': backgroundColor || '#ffffff', 'color': font_color || '#000000' }">
        <b>{{ highlight }}</b>
      </div>
      <div class="dialog-content-wrapper">
        <div class="video-container" (touchstart)="handleTouchStart($event)" (touchmove)="handleTouchMove($event)"
          (touchend)="handleTouchEnd($event)" (mousedown)="handleMouseDown($event)"
          (mousemove)="handleMouseMove($event)" (mouseup)="handleMouseUp($event)">
          <p-skeleton *ngIf="loading" height="200px" width="100%"></p-skeleton>
          <video *ngIf="selectedVideoUrl" #videoPlayer [muted]="true" [autoplay]="true" [loop]="true"
            [poster]="selectedVideoUrl.thumbnail" (loadedmetadata)="onVideoLoaded()" [src]="selectedVideoUrl.src">
            Seu navegador não suporta a tag de vídeo.
          </video>
        </div>
      </div>
    </div>
  </div>
</app-fake-page-preview>

<!-- Não-admin: p-dialog normal posicionado na viewport -->
<p-dialog *ngIf="!isAdmin" #dialogContainer [(visible)]="visible" [position]="position" [draggable]="false"
  [style.pointer-events]="disableClicks ? 'none' : 'auto'" [ngClass]="[getDialogClass(), position]"
  (onShow)="onDialogShow()" (mouseenter)="onDialogMouseEnter()" (mouseleave)="onDialogMouseLeave()"
  class="ss-l-dialog-popup">
  <ng-template pTemplate="content">
    <div appDraggable [position]="position" [resetPosition]="resetPosition" (dragEnd)="onDragEnd()"
      class="ss-l-dialogBody" [style.pointer-events]="disableClicks ? 'none' : 'auto'">
      <div #highlightElement class="ss-l-highlight pr-3 pl-3 pb-1 pt-1"
        *ngIf="highlight && highlight.length > 0 && showHighlight"
        [ngStyle]="{ 'background-color': backgroundColor || '#ffffff', 'color': font_color || '#000000' }">
        <b>{{ highlight }}</b>
      </div>
      <div class="dialog-content-wrapper">
        <div class="video-container" (touchstart)="handleTouchStart($event)" (touchmove)="handleTouchMove($event)"
          (touchend)="handleTouchEnd($event)" (mousedown)="handleMouseDown($event)"
          (mousemove)="handleMouseMove($event)" (mouseup)="handleMouseUp($event)">
          <p-skeleton *ngIf="loading" height="200px" width="100%"></p-skeleton>
          <video *ngIf="selectedVideoUrl" #videoPlayer [muted]="true" [autoplay]="true" [loop]="true"
            [poster]="selectedVideoUrl.thumbnail" (loadedmetadata)="onVideoLoaded()" [src]="selectedVideoUrl.src">
            Seu navegador não suporta a tag de vídeo.
          </video>
        </div>
      </div>
    </div>
  </ng-template>
</p-dialog>






